import { Formik } from "formik";
import { Form, Col, Row } from "react-bootstrap";

export function ReportDefinitionEditForm({
  schoolReport,
  btnRef,
  saveSchoolReport
 }) {
  return (
    <Formik 
      enableReinitialize={true}
      initialValues={schoolReport}
      onSubmit={(values) => {
        saveSchoolReport(values);
      }}
    >
      {({ handleSubmit, handleChange, values }) => (
        <Form onSubmit={(e) => {
          e.preventDefault();
          handleSubmit();
        }}>
          <Form.Group as={Row} controlId="name">
            <Form.Label column sm={2}>
              Karne Adı<span> *</span>
            </Form.Label>
            <Col sm={6}>
              <Form.Control type="text" value={values.name} placeholder="Karne Adı" onChange={handleChange} />
            </Col>
          </Form.Group>
                        
          <Form.Group as={Row} controlId="description">
            <Form.Label column sm={2}>
              Açıklama
            </Form.Label>
            <Col sm={6}>
              <Form.Control type="text" value={values.description} placeholder="Açıklama" onChange={handleChange} />
            </Col>
          </Form.Group>
                        
          <Form.Group as={Row}>
            <Form.Label column sm={2}>
              Dönem<span> *</span>
            </Form.Label>
            <Col sm={3}>
              <Form.Control
                type="number"
                min={0}
                value={values.term}
                id="term" 
                placeholder="Dönem"
                onChange={e => {
                  handleChange(e)
                  handleChange("term2")(e);
                }}
              />
            </Col>
            <Col sm={3}>
              <Form.Control value={values.term + 1} id="term2" readOnly />
            </Col>
          </Form.Group>

          <Form.Group as={Row} controlId="startDate">
            <Form.Label column sm={2}>
              Başlangıç Tarihi<span> *</span>
            </Form.Label>
            <Col sm={6}>
              <Form.Control type="date" value={values.startDate} placeholder="Başlangıç Tarihi" onChange={handleChange} />
            </Col>
          </Form.Group>
                            
          <Form.Group as={Row} controlId="endDate">
            <Form.Label column sm={2}>
              Bitiş Tarihi<span> *</span>
            </Form.Label>
            <Col sm={6}>
              <Form.Control type="date" value={values.endDate} placeholder="Bitiş Tarihi" onChange={handleChange} />
            </Col>
          </Form.Group>

          <button
            type="submit"
            style={{ display: "none" }}
            ref={btnRef}
          ></button>
        </Form>
      )}      
    </Formik>
  );
}